/** Fired when message read state changes (mark read, new message, etc.). */
export const MESSAGING_UNREAD_CHANGED_EVENT = 'bahlus-messaging-unread-changed';

export function dispatchMessagingUnreadChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MESSAGING_UNREAD_CHANGED_EVENT));
  }
}
